import { createConsumer, createSubscriber, getGlobalEventsLogs, IEvent } from '@cian/events-log';
import * as React from 'react';

import { IOpenModalParams } from '../types';

interface IParameters {
  openModal(params?: IOpenModalParams): void;
}

export function useEventsLog({ openModal }: IParameters) {
  React.useEffect(() => {
    const feedbackConsumer = createConsumer({ topic: 'feedback' });

    const feedbackSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'open') {
        const params = event.value as IOpenModalParams | undefined;

        openModal(params?.topic ? params : undefined);

        const globalLog = getGlobalEventsLogs();

        globalLog.produce('feedback', { type: 'popup_opened', value: true });
      }
    });

    feedbackConsumer.subscribe(feedbackSubscriber);

    return () => {
      feedbackConsumer.unsubscribe(feedbackSubscriber);
      feedbackConsumer.destroy();
    };
  }, [openModal]);
}
